export enum SystemTag {
  API = 'API',
  SERVICE = 'SERVICE',
}
